import { prepareHttpHeaders } from "../utils/http";
import loginService from "../utils/login-service";
import { setEnv } from "../utils/env";

const fetchData = (url, params) => fetch(url, params).then(res => res.json());
const createPostRequest = (url, data, params) =>
  fetchData(url, {
    headers: prepareHttpHeaders(),
    method: "POST",
    body: JSON.stringify(data),
    ...params
  });

export const createMobileApiRequest = async ({
  url,
  data = {},
  params = {},
  configuration
}) => {
  const { baseUrl, apiToken, bundleIdentifier, authorization } = configuration;
  setEnv({
    BASE_URL: baseUrl,
    API_TOKEN: apiToken,
    BUNDLE_ID: bundleIdentifier
  });

  try {
    const memberId = await loginService(authorization);
    if (!memberId) throw new Error("Can't get member id");

    const body = { logged_in_member_id: memberId, ...data };
    const response = await createPostRequest(url, body, params);

    if (response.error_code === 2) {
      setEnv({ AUTH_TOKEN: "" });
      return Promise.reject(new Error("WEBSDK_AUTH_ERROR"));
    }

    return response;
  } catch (err) {
    throw new Error(err);
  }
};
